// extracted by mini-css-extract-plugin
module.exports = {"reorderMemberInstructionsContainer":"_reorderMemberInstructionsContainer--1-x-Y","moveInstructions":"_moveInstructions--oZPmN"};